import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material';
import { Filtro } from '../models/filtro';
import { UtilitarioService } from '../services/utilitario.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PaginatorService } from '../services/paginator.service';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { GrupoMotivoPerda } from '../models/grupo-motivo-perda';
import { GrupoMotivoPerdaService } from '../services/grupo-motivo-perda.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-grupo-motivo-perda',
  templateUrl: './grupo-motivo-perda.component.html',
  styleUrls: ['./grupo-motivo-perda.component.scss']
})
export class GrupoMotivoPerdaComponent implements OnInit {
  grupoMotivoPerda: GrupoMotivoPerda[] = [];
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'descricao', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private grupoMotivoPerdaService: GrupoMotivoPerdaService,
    private utilitarioService: UtilitarioService,
    private router: Router,
    private paginatorService: PaginatorService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarGrupos();
  }

  novoGrupo() {
    this.router.navigate(['novo'], { relativeTo: this.route });
  }

  editarGrupo(grupo: GrupoMotivoPerda) {
    this.router.navigate(['editar', grupo.id], { relativeTo: this.route });
  }

  buscarGrupos() {
    this.carregandoService.mostra('buscaGrupos');
    this.carregando = true;

    this.grupoMotivoPerdaService.consultarGruposComPaginacao(this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe((data: any) => {
        this.paginator.firstPage();
        this.grupoMotivoPerda = data.itens;
        this.listaDeItensPorPagina = this.utilitarioService.calculaItensPorPagina(data.total);

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = data.total;

        this.carregando = false;
        this.carregandoService.esconde('buscaGrupos');

      }, (erro) => {
        this.carregandoService.esconde('buscaGrupos');
        this.notificacaoService.erro(erro);
      });
  }

  mudaDePagina(pageEvent: PageEvent) {
    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarGrupos();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.grupoMotivoPerda = this.grupoMotivoPerda.sort((a, b) => {
        const isAsc = !this.ordenarDesc;

        switch (this.campoOrdenacao) {
          case 'descricao': return this.compare(a.descricao, b.descricao, isAsc);
          default: return 0;
        }
      });

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  filtra() {
    this.buscarGrupos();
    this.paginator.firstPage();
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  excluir(grupo: GrupoMotivoPerda) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir este grupo?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirEmb');

        this.grupoMotivoPerdaService.excluir(grupo.id).subscribe(data => {
          this.notificacaoService.sucesso("Grupo excluído com sucesso!");
          this.carregandoService.esconde('excluirEmb');
          this.filtra();
        }, (erro) => {
          this.carregandoService.esconde('excluirEmb');
          this.notificacaoService.erro("Não foi possível excluir este grupo.");
        });
      }
    });
  }
}
